import {
  IconDefinition,
  IconName,
  IconPrefix,
} from '@fortawesome/fontawesome-svg-core';

/**
 * Duotone broom from Font Awesome Pro 7.1.0 (svgs/duotone/broom.svg), with
 * the layers regrouped: the stock icon fades the handle, but we want the
 * sweeping head separately styleable. The head renders as `.fa-secondary`
 * and the handle + collar as `.fa-primary`, so they can be colored
 * independently via `--fa-secondary-color` / `--fa-primary-color`.
 */
export const faBroomDuotone: IconDefinition = {
  prefix: 'fac' as IconPrefix,
  iconName: 'broom-duotone' as IconName,
  icon: [
    576,
    512,
    [],
    '',
    [
      'M341.1 353.4L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3l-8 8c-22.3 22.3-34.8 52.5-34.8 84 0 6.8 7.1 11.2 13.2 8.2l29.9-15c8.3-4.2 15.9 6.9 8.9 13.1L7.3 473.4C2.7 477.6 0 483.6 0 489.9 0 502.1 9.9 512 22.1 512l173.3 0c38.8 0 75.9-15.4 103.4-42.8 30.6-30.6 45.9-73.1 42.3-115.8z',
      'M329.4 201.4c15.1 15.1 30.2 30.2 45.3 45.3l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192zM409.4 281.4L294.6 166.6c-4.2-4.2-10-6.6-16-6.6-12.5 0-22.6 10.1-22.6 22.6l0 29.1 108.3 108.3 29.1 0c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16z',
    ],
  ],
};
